import { createApiCallActions } from '../../../common/store/generic.actions';
import { ClaimTypeModel } from './types';

export const claimTypeActions = {
  getById: createApiCallActions<ClaimTypeModel>('claimType', 'getById'),
  createInstance: createApiCallActions<ClaimTypeModel>(
    'claimType',
    'createInstance',
  ),
  add: createApiCallActions<ClaimTypeModel>('claimType', 'add'),
  update: createApiCallActions<ClaimTypeModel>('claimType', 'update'),
  delete: createApiCallActions<boolean>('claimType', 'delete'),
};

export type ClaimTypeAction = typeof claimTypeActions;
